import { DateTime } from 'luxon'

const filters = {
    luxonTime(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return date.toFormat('HH:mm')
    },
    luxonShortDate(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return date.toLocaleString(DateTime.DATE_HUGE)
    },
    luxonSortableDateTime(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return date.toFormat('yyyy-MM-dd HH:mm:ss')
    },
    luxonSortableDate(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return date.toFormat('yyyy-MM-dd')
    },
    luxonToolTipDateTime(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return `${date.toLocaleString(DateTime.DATE_HUGE)} at ${date.toLocaleString(DateTime.TIME_24_WITH_SECONDS)}`
    },
    luxonWeekdayTime(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return date.toFormat('EEE HH:mm')
    },
    luxonShortDayDate(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return date.toFormat('EEE, MMM dd, yyyy')
    },
    luxonPostedAgo(value) {
        let date = parseValue(value)
        if (!isValid(date)) {
            return 'Invalid Date'
        }
        return date.toRelative()
    },
}

function parseValue(value) {
    if (DateTime.isDateTime(value)) {
        return value
    }
    return DateTime.fromISO(value)
}

function isValid(value) {
    if (!value || value === 'Invalid DateTime' || (DateTime.isDateTime(value) && !value.isValid)) {
        return false
    }
    return true
}

export default filters
